import styled from "styled-components";
import { rainbowTextGradient } from "../../components/StyledComponents";

export const Card = styled('div')`
  margin: 0 auto;
  max-width: 450px;
`

export const Title = styled("h1")`
  font-weight: 500;
  line-height: normal;
  font-size: 28px;
  margin: 0px;
  text-align: center;
`;

export const Subtitle = styled("h4")`
  margin: 0px;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  text-align: center;
  ${rainbowTextGradient};

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    letter-spacing: .5px;
  }
`;


export const Text = styled('p')`
  margin: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  color: #1A1A1A;

  strong {
    font-weight: 500;
  }
`

export const Line = styled('div')`
  height: 1px;
  width: 100%;
  background-color: #2D3436;
  opacity: .5;
`

export const FooterMessage = styled('p')`
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #69779B;
`